export enum OcbAzureStorageAuthenticationModes {
    AccessKey = 0,
    SasToken = 1,
    EntraId = 2
}
